import { useCallback } from 'react';

export function useHardwareAcceleration() {
  const isWebGLAvailable = useCallback((): boolean => {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      return !!gl;
    } catch {
      return false;
    }
  }, []);

  return { isWebGLAvailable };
}
